/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/
import {dynRem, eventEmitter} from "./common/baseData";

import './reviews/style.css';
import './pagenavigation/style.css';
import {ProductList} from "./catalog/product.list";
import React from 'react';
import {createRoot} from 'react-dom/client';
import CreateReview from "./components/reviews/createReview/CreateReview";

function parseReviewData(raw) {
    if (!raw) return null;

    try {
        return JSON.parse(atob(raw));
    } catch (e) {
        try {
            return JSON.parse(raw);
        } catch (innerError) {
            console.error(innerError);
            return null;
        }
    }
}

function initCreateReviewButtons() {
    const buttons = [].slice.apply(document.querySelectorAll('[data-use="create-review"]'));
    if (!buttons.length) return;

    let rootNode = document.getElementById('category-create-review-root');
    if (!(rootNode instanceof HTMLElement)) {
        rootNode = document.createElement('div');
        rootNode.id = 'category-create-review-root';
        document.body.appendChild(rootNode);
    }

    const root = createRoot(rootNode);
    const items = [];

    buttons.forEach((button, index) => {
        if (!(button instanceof HTMLElement) || button.dataset.reviewInit === 'true') return;

        const props = parseReviewData(button.dataset.review) || {
            postId: Number(button.dataset.postId || 0),
            blogId: Number(button.dataset.blogId || 0),
            productId: Number(button.dataset.productId || 0),
        };

        if (!props.postId || !props.productId) return;

        const uniqueId = `category-review-${index}`;
        button.dataset.reviewUid = uniqueId;
        button.dataset.reviewInit = 'true';
        items.push(<CreateReview key={uniqueId} {...props} uniqueId={uniqueId}/>);
    });

    if (items.length) {
        root.render(<>{items}</>);
    }
}


// Products list
let productList;
let catalogProductBlock = document.querySelector('[data-container="product-list"]');
if (catalogProductBlock instanceof HTMLElement) {
    try {
        let params = JSON.parse(atob(catalogProductBlock.dataset['params']));
        params.node = catalogProductBlock;
        productList = new ProductList(params);

        //Retargeting
        if (params.hasOwnProperty('data_layer'))
            dynRem.pushToDataLayer(params['data_layer']);

        //Wishlist
        eventEmitter.emit('handleWishlistItems', {
            node: catalogProductBlock.querySelectorAll('[data-container="favorite"]'),
            range: 'category'
        });

        //Compare
        eventEmitter.emit('handleCompareItems', {
            node: catalogProductBlock.querySelectorAll('[data-container="compare"]'),
            range: 'category'
        });

        // Pagination
        let catalogPaginationBlock = document.querySelector('[data-container="page-paging"]');
        if (catalogPaginationBlock instanceof HTMLElement) {
            let params = JSON.parse(atob(catalogPaginationBlock.dataset['params']));
            import(/* webpackPreload: true */ './pagenavigation')
                .then(({default: CatalogPagenation}) => {
                    params.node = catalogPaginationBlock;

                    productList.pagen = new CatalogPagenation(params);
                    productList.pagen.init();

                    eventEmitter.on('show-more', (e) => {
                        if (typeof productList.pagen !== 'object') return;
                        try {
                            if (!productList.pagen.lazy || productList.pagen.getCurrentPage() >= productList.pagen.getLastPage()) return;
                            productList.loadNextPage().then((response) => {
                                productList.params.node.insertAdjacentHTML('beforeEnd', response);
                                initCreateReviewButtons();
                                productList.pagen.setNextPageNumber();
                                productList.pagen.activePageNode();
                                if (productList.pagen.isLastPage) {
                                    productList.pagen.hideShowMoreButton();
                                    productList.pagen.node.style.display = 'none';
                                }
                                // Wish list items update state
                                eventEmitter.emit('handleWishlistItems', {
                                    node: catalogProductBlock.querySelectorAll('[data-container="favorite"]'),
                                    range: 'category'
                                });

                                eventEmitter.emit('handleCompareItems', {
                                    node: catalogProductBlock.querySelectorAll('[data-container="compare"]'),
                                    range: 'category'
                                });
                            });
                        } catch (error) {
                            console.error(error);
                        }

                    });
                });
        }

    } catch (e) {
        console.error(e);
    }
}

initCreateReviewButtons();

let pageBlockNode = document.querySelector('[data-container="product-list"]');
if (pageBlockNode instanceof HTMLElement) {
    pageBlockNode.addEventListener('click', event => {
        let node = event.target.closest('[data-use], [data-type]');
        if (!(node instanceof HTMLElement)) {
            return;
        }

        if (node.dataset.hasOwnProperty('use') && node.dataset.use === 'create-review') {
            event.preventDefault();

            if (node.dataset.reviewUid) {
                eventEmitter.emit(`showForm${node.dataset.reviewUid}`);
            }

            return;
        }

        if (node.dataset.hasOwnProperty('use') && node.dataset.use === 'create-comment') {
            event.preventDefault();

            let el = node, holder = el.closest('.dropdown-main-container');
            let data = {
                component: {
                    params: el.dataset.params,
                    component: el.dataset.component,
                    commentCreateTemplate: el.dataset.commentCreateTemplate,
                    commentSuccessTemplate: el.dataset.commentSuccessTemplate
                },
                postId: el.dataset.postId,
                blogId: el.dataset.blogId,
                productId: el.dataset.productId,
                loadUrl: atob(el.dataset.loadUrl),
                editUrl: atob(el.dataset.editUrl)
            };

            import(/* webpackChunkName: 'productreview' */ './productReview').then(module => {
                let productReview = new module.ProductReview(data);
                productReview.loadCommentTemplate()
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.hasOwnProperty('html') && data.html.length) {
                            holder.insertAdjacentHTML('beforeEnd', data.html);
                            // Show comment block
                            holder.querySelector('.dropdown-holder').setAttribute('style', 'visibility: visible; opacity: 1; z-index: 20;');
                            // Form submit event, check fields and send form data
                            holder.querySelector('form[name="comment"]')
                                .addEventListener('submit', event => {
                                    event.preventDefault();
                                    // Validate data
                                    if (productReview.validate(event.target)) {
                                        // Prepare comment data
                                        let requestData = productReview.fieldsData(event.target);
                                        requestData.append('action', 'createReview');
                                        requestData.append('parentId', el.dataset.reviewId);
                                        requestData.append('postId', productReview.postId);
                                        requestData.append('blogId', productReview.blogId);
                                        requestData.append('productId', productReview.productId);
                                        productReview.sendCommentData(requestData) // Send review data
                                            .then(response => {
                                                return response.json(); // Parse json response
                                            })
                                            .then(response => { // Processing response
                                                console.dir(response);
                                                if (response.success && parseInt(response.reviewId, 10) > 0) { // Review success created
                                                    return productReview.loadCommentSuccessTemplate(); // Load success template
                                                } else if (response.errors.length > 0) {
                                                    let text = response.errors.join(", ");
                                                    throw text;
                                                }
                                            })
                                            .then(response => {
                                                return response.json();
                                            })
                                            .then(response => { // Processing success template
                                                if (response.hasOwnProperty('html') && response.html.length) {
                                                    holder.querySelector('.dropdown-content-te').innerHTML = response.html;
                                                }
                                            }).catch(e => {
                                            console.dir(e);
                                            holder.querySelector('.dropdown-content-te').innerHTML = e;
                                        });
                                    }
                                });
                            // Change fields values
                            holder.querySelector('form[name="comment"]')
                                .addEventListener('change', event => {
                                    event.preventDefault();
                                    // Validate data
                                    productReview.validateField(event.target);
                                    // Toggle has value
                                    productReview.toggleInputHasValue(event.target);
                                });
                            // Close comment block
                            holder.querySelector('.close')
                                .addEventListener('click', event => {
                                    let dropHolder = holder.querySelector('.dropdown-holder');
                                    if (dropHolder instanceof HTMLElement) {
                                        holder.removeChild(dropHolder);
                                    }
                                });
                        }
                    });
            });

        }
        else if (node.dataset.hasOwnProperty('use') && node.dataset.use === 'show-comments') {
            event.preventDefault();
            event.stopPropagation();

            let commentsHolder = node.closest('.testimonial-block')
              .querySelector('[data-container="review"][data-use="comments-holder"]');
            if (commentsHolder instanceof HTMLElement) {
                commentsHolder.classList.toggle('show');
            }
        }
        else if (node.dataset.hasOwnProperty('use') && node.dataset.use === 'add') {
            let el = node;
            let data = {
                component: {
                    params: el.dataset.params,
                    component: el.dataset.component,
                    reviewCreateTemplate: el.dataset.reviewCreateTemplate,
                    reviewSuccessTemplate: el.dataset.reviewSuccessTemplate
                },
                postId: el.dataset.postId,
                blogId: el.dataset.blogId,
                productId: el.dataset.productId,
                loadUrl: atob(el.dataset.loadUrl),
                editUrl: atob(el.dataset.editUrl),
                messages: JSON.parse(atob(el.dataset.messages))
            };

            import(/* webpackChunkName: 'productreview' */ './productReview').then(module => {
                let productReview = new module.ProductReview(data);
                productReview.loadTemplateData()
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {
                        if (data.hasOwnProperty('html') && data.html.length) {
                            eventEmitter.on('popupAfterOpen', popup => {
                                if (productReview.id === popup.id) {
                                    // Form submit event, check fields and send form data
                                    let form = productReview.body.querySelector('form');
                                    form.addEventListener('submit', event => {
                                        event.preventDefault();
                                        // Validate data
                                        if (productReview.validate(form))
                                            productReview.sendReviewData(form) // Send review data
                                                .then(response => {
                                                    return response.json(); // Parse json response
                                                })
                                                .then(response => { // Processing response
                                                    if (response.success && parseInt(response.reviewId, 10) > 0) { // Review success created
                                                        return productReview.loadSuccessTemplate(); // Load success template
                                                    } else console.log('Some error');
                                                })
                                                .then(response => {
                                                    return response.json();
                                                })
                                                .then(response => { // Processing success template
                                                    if (response.hasOwnProperty('html') && response.html.length) {
                                                        productReview.body = response.html;
                                                    }
                                                });
                                    });
                                    // Change fields values
                                    productReview.body.querySelector('form')
                                        .addEventListener('change', event => {
                                            event.preventDefault();
                                            // Validate data
                                            productReview.validateField(event.target);
                                            // Toggle has value
                                            productReview.toggleInputHasValue(event.target);
                                        });
                                }
                            });
                            productReview.body = data.html;
                            productReview.open();
                        }
                    });
            });
        }
        else if (node.dataset.hasOwnProperty('type') && node.dataset.type === 'show-more-reviews') {
            let moreListBlockNode = node.parentNode.parentNode.querySelector('[data-container="more-reviews"]');
            if (moreListBlockNode instanceof HTMLElement)
                moreListBlockNode.style.display = 'block';

            node.remove();
        }

    });
}



